import { render } from "./PMemberCenter.vue?vue&type=template&id=1f401972&scoped=true"
import script from "./PMemberCenter.vue?vue&type=script&lang=js"
export * from "./PMemberCenter.vue?vue&type=script&lang=js"

import "./PMemberCenter.vue?vue&type=style&index=0&id=1f401972&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f401972"]])

export default __exports__